module.exports = __webpack_public_path__ + "static/media/giant_paper_straw3.dc3adaca.png";